export const INKO_STATES = Object.freeze({
    IDLE: "idle",
    THINKING: "thinking",
    CLARIFYING: "clarifying",
    ASSET_MATCHING: "asset_matching",
    WAITING_ASSET: "waiting_asset",
    PLANNING: "planning",
    GENERATING: "generating",
    COMPOSING: "composing",
    VALIDATING: "validating",
    COMPLETED: "completed",
    EDITING: "editing",
    FAILED: "failed",
});

export const state = {
    status: INKO_STATES.IDLE,

    conversationId: null,

    designId: null,

    versionId: null,

    messages: [],

    design: null,

    zoom: 1,

    pollingTimer: null,
};

export function setState(values = {}) {
    Object.assign(state, values);

    window.dispatchEvent(
        new CustomEvent("inko:state", {
            detail: state,
        }),
    );
}

export function addMessage(message) {
    state.messages.push(message);

    window.dispatchEvent(
        new CustomEvent("inko:message", {
            detail: message,
        }),
    );
}

export function resetConversation() {
    state.conversationId = null;
    state.designId = null;
    state.versionId = null;
    state.messages = [];
    state.design = null;
    state.status = INKO_STATES.IDLE;
}
